import React, { useState } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, Input, message, Select } from "antd";
import "./style.less";

const TextArea = Input.TextArea;
const InputGroup = Input.Group;
const { Option } = Select;

const App = () => {

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(undefined);
    const [sex, setSex] = useState(undefined);
    const [orgName, setOrgName] = useState(undefined);
    const [phone, setPhone] = useState(undefined);
    const [remarks, setRemarks] = useState(undefined);
    const [[{ title, show, hide, width = 300 }]] = useWatchState(["modal.forumCooperation"])

    const onSign = async () => {
        if (!name) return message.warn("请输入姓名！");
        if (!phone) return message.warn("请输入电话！");
        setLoading(true)
        // 先判断是否已经报过名了
        const res = await BaseService.list({
            table: "thtt_forum_cooperation",
            where: {
                name, phone, is_delete: 0
            }
        })
        if (res.data.result.length) return message.warn("您已提交合作意向申请，请耐心等待我们的工作人员与您联系");

        const addRes = await BaseService.add({
            table: "thtt_forum_cooperation",
            data: { name, sex, org_name: orgName, phone, remarks, add_time: new Date().format("yyyy-MM-dd hh:mm:ss"), is_delete: 0 }
        });
        setLoading(false)
        if (addRes.data.status !== 200) {
            message.error(addRes.data.msg);
            return;
        }
        message.success("提交成功，我们会尽快与您联系！");
        hide();
    }

    return (
        <Modal
            className="modal-courseSignUp"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div className="modal-courseSignUp__body child-top-sm p-md-lr">
                <InputGroup compact>
                    <Input style={{ width: '70%' }} placeholder="请输入您的姓名" onChange={e => setName(e.target.value)} />
                    <Select style={{ width: '30%' }} defaultValue="0" onChange={e => setSex(e)}>
                        <Option value="0">男</Option>
                        <Option value="1">女</Option>
                    </Select>
                </InputGroup>
                <Input placeholder="请输入您的单位" onChange={e => setOrgName(e.target.value)} />
                <Input placeholder="请输入您的电话" onChange={e => setPhone(e.target.value)} />
                <TextArea placeholder="备注（任何您需要告诉我们的）" rows={5} onChange={e => setRemarks(e.target.value)} />
                <div className="modal-courseSignUp__btn child-left-sm flex">
                    <Button type="default" onClick={hide}>取消</Button>
                    <Button className="full" onClick={onSign}>提交</Button>
                </div>
            </div>
        </Modal>
    );
}

export default App;